/**
 * @typedef {import('sweetalert2').SweetAlertOptions} SwalParams
 */

export default class Brain {
  /**
   *
   * @param {Object} Vue
   * @param {Object} Vue.prototype
   * @param {import('./Company').default} Vue.prototype.$company
   * @param {import('./User').default} Vue.prototype.$user
   * @param {import('./Portal').default} Vue.prototype.$portal
   * @param {import('./Utils').default} Vue.prototype.$utils
   * @param {import('./CurrentModule').default} Vue.prototype.$currentModule
   * @param {import('./DirectScript').default} Vue.prototype.$directScript
   * @param {import('./Format').default} Vue.prototype.$format
   * @param {import('./Swal').default} Vue.prototype.$swal
   */
  constructor(Vue) {
    // Force inject (init vue)
    this.route = {};
    this.router = {};

    this.company = Vue.prototype.$company;
    this.user = Vue.prototype.$user;
    this.portal = Vue.prototype.$portal;
    this.utils = Vue.prototype.$utils;
    this.currentModule = Vue.prototype.$currentModule;
    this.directScript = Vue.prototype.$directScript;
    this.format = Vue.prototype.$format;
    this.proSwal = Vue.prototype.$swal;
    this.cookies = Vue.prototype.$cookies;
    this.chat = Vue.prototype.$chat;
    this.script = Vue.prototype.$script;

    Vue.prototype.$user.brain = this;

    /** @legacy - instância do Vue dos scripts (caso o mesmo atribua o valor) */
    this.scriptVm = {};

    /** Valores que necessitam ser validados apenas uma vez (no start do app) */
    this.routerOnceEvaluated = {};

    this.goBackFunction = null;
    this.isHeaderHided = false;
    this.headerHeight = 100;
  }

  /**
   * =============
   * FACILITATORS
   * =============
   */
  async getBanners() {
    try {
      const result = await brain.utils.ajaxMicroservice({
        method: 'GET',
        uri: `/v1/session/app/${brain.company.json.id}/banners`,
        microservice: 'app',
      });
      return result;
    } catch (err) {
      console.error('Error getBanners', err);
    }
  }

  openProfile() {
    this.openModal('.proModalProfile');
  }

  closeProfile() {
    this.closeModal('.proModalProfile');
  }

  openPassword() {
    this.openModal('.proModalPassword');
  }

  closePassword() {
    this.closeModal('.proModalPassword');
  }

  openHost() {
    this.openModal('.proModalHost');
  }

  closeHost() {
    this.closeModal('.proModalHost');
  }

  openAudit() {
    if (!_.get(this.company.json, 'entity.radar')) return;
    this.openModal('.proModalAudit');
  }

  closeAudit() {
    this.closeModal('.proModalAudit');
  }

  openFeedback() {
    this.openModal('.proModalFeedback');
  }

  closeFeedback() {
    this.closeModal('.proModalFeedback');
  }

  closeAllModals() {
    this.closeModalModule();
    this.closeModal('.proModalDashboard');
    this.closeModal('.proModalFeedback');
    this.closeModal('.proModalAudit');
    this.closeModal('.proModalHost');
    this.closeModal('.proModalPassword');
    this.closeModal('.proModalProfile');
  }

  async openModalDashboard() {
    const contents = await this.getBanners();
    if (
      Array.isArray(contents) && contents.length > 0
      && this.user.hasEntity
    ) {
      const content = contents.map(i => {
        if (i && i.html) return i.html;
        return '';
      }).join('');
      const cookieContent = this.cookies.get('modal-dashboard-watched');

      if (!cookieContent || content !== cookieContent) {
        setTimeout(() => {
          $('.proModalDashboard').modal('show');
          if (!this.company.json.modalDashboard.setCookieWatched) return;

          this.cookies.set(
            'modal-dashboard-watched',
            content,
          );
        }, 100);
      }
    }
  }

  openModalModule() {
    if (!this.company.moduleOpen || !this.company.itemOpen) return;

    const contents = _.get(this.company.itemOpen, 'modal.items');

    if (
      !Array.isArray(contents)
      || contents.length === 0
      || $(window).width() <= '768'
    )
      return;

    const content = contents.map(i => (i && i.html ? i.html : '')).join('');

    /** Abre o modal se o parâmetro set cookies não é true */
    if (!_.get(this.company, 'itemOpen.modal.setCookieWatched')) {
      this.openModal('.proModalModule');
      return;
    }

    const COOKIE_NAME = `modal-module-${this.company.moduleOpen.id}-item-${this.company.itemOpen.id}-watched`;
    const COOKIE_CONTENT = this.cookies.get(COOKIE_NAME);

    /**
     * Abre o modal se o cookie não existe
     * ou se ele é diferente do conteúdo transformado em String
     */
    if (!COOKIE_CONTENT && content !== COOKIE_CONTENT)
      this.openModal('.proModalModule');

    this.cookies.set(COOKIE_NAME, content);
  }

  closeModalModule() {
    this.closeModal('.proModalModule');
  }

  openModal(arg) {
    $(arg).modal('show');
  }

  closeModal(arg) {
    $(arg).modal('hide');
  }

  openChat() {
    this.chat.open(_.get(this.company.json, 'chat.type'));
  }

  closeChat() {
    this.chat.close(_.get(this.company.json, 'chat.type'));
    window.location.reload();
  }

  lockBodyScroll() {
    document.body.style.overflow = 'hidden';
  }

  unlockBodyScroll() {
    document.body.style.overflow = 'auto';
  }

  /**
   * =========
   * ACTIVITY
   * =========
   */

  setActivity(pointer, json, sendNotification) {
    return new Promise((resolve, reject) => {
      const userInfo = {
        nick: this.user.json.nick,
        phone: this.format.formatPhone(this.user.json.phone),
        email: this.user.json.email,
      };

      if (json) json.appVersion = this.getBrowserInfo();

      this.utils.proCore.setActivity(pointer, json, { sendNotification, userInfo })
        .then(() => resolve())
        .catch(err => {
          console.log(`ERROR SET_ACTIVITY ${pointer}`);
          reject(err);
        });
    });
  }

  /**
   * ============
   * CUSTOM FILE
   * ============
   */
  saveFile(model, fileType, body) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        crossDomain: true,
        contentType: 'application/json',
        url: `${this.portal.url.endPoint.core}/customFile/save`,
        headers: {
          companyId: this.user.json.id,
          token: this.user.token,
          model,
          type: fileType,
        },
        data: body,
      })
        .then(res => resolve(res))
        .fail(err => {
          console.log(err);
          reject('#ERRO_SAVE_FILE');
        });
    });
  }

  /**
   * ============
   * UPLOAD FILE (microservice)
   * ============
   */
  uploadFile({
    path,
    type,
    expires = 0,
    storageType = 'tmp-public-link',
    base64,
  }) {
    return new Promise((resolve, reject) => {
      $.ajax({
        method: 'POST',
        crossDomain: true,
        url: `${this.portal.url.endPoint.file}/v1/app/${this.user.json.id}/upload`,
        headers: {
          'Content-Type': 'application/json',
          code: this.user.token,
          path,
          type,
          expires,
          storageType,
        },
        data: JSON.stringify({ file: base64 }),
      })
        .then(res => {
          if (!res.data.key) {
            return reject({
              status: '#ERROR_UPLOAD_FILE',
              message: 'Ocorreu um erro ao salvar o arquivo!',
              error: res,
            });
          }
          return resolve(res);
        })
        .catch(error => reject({
          status: '#ERROR_UPLOAD_FILE',
          message: 'Ocorreu um erro ao salvar o arquivo!',
          error,
        }));
    });
  }

  /**
   * ========
   * COMPANY
   * ========
   */
  disableScriptLoading() {
    this.company.disableScriptLoading();
  }

  /**
   * =======
   * SCRIPT
   * =======
   */
  /**
   * Realiza o fechamento de um script @legacy
   */
  closeScript(err, force = false) {
    if (this.company.itemScriptLoading && !force) return;
    this.company.closeModuleItem(err);
    this.isLegacyScriptOpen = false;
    this.portal.resetLayout();
    /** remove o script */
    this.script.clearOldScript();
    /**
     * Se o script disponibilizou a sua VM (instancia do Vue) ao brain,
     * é possível destruí-la sem deixar resquicios do mesmo
     */
    if (this.scriptVm.$destroy) {
      this.scriptVm.$destroy();
      this.scriptVm = {};
    }
  }

  /**
   * Método responsável por realizar o "fechamento" de um
   * Script (LEGACY) e de um módulo
   */
  closeModule(err, force = false) {
    if (this.company.itemScriptLoading && !force) return;
    if (this.isLegacyScriptOpen) return this.closeScript(err, force);

    const currentMainRoute = this.router.currentRoute.path.split('/')[1];
    /**
     * Ao realizar um router push para "raíz" irá disparar o evento
     * `beforeRouterLeave` do wrapper de module, que será responsável
     * por fechar o modulo em execução
     */
    this.redirectToPath(`/${currentMainRoute}`);
  }

  openModuleById({ moduleId, itemId, changeRoute }) {
    const module = _.get(this.company, 'json.module', []).find(m => m.id === moduleId) || { item: [] };
    const item = module.item.find(i => i.id === itemId);

    if (!item) return;

    brain.openModule({ module, item, changeRoute });
  }

  async openModule({
    module, item, changeRoute = true, bypassLoading = false,
  } = {}) {
    if (this.company.itemScriptLoading) return;

    this.isLegacyScriptOpen = false;
    /**
     * Utilizar router.currentRoute ao invés de route,
     * pois o route não está mudando de referencia e não está refletindo as alterações de rota
     */
    const currentMainRoute = this.router.currentRoute.path.split('/')[1];

    /** @LEGACY */
    if (item.script.endsWith('.js')) {
      if (changeRoute) {
        const path = `/${currentMainRoute}`;
        await this.redirectToPath(path); // espera a saída do module para abrir o script
      }

      this.company.openModuleItem(module, item, bypassLoading);
      this.isLegacyScriptOpen = true;
      return;
    }

    this.company.openModule(module, item);
    if (changeRoute) {
      // ? Config para abrir o módulo em outra rota (scripts legacy não terão esta funcionalidade)
      const newRoute = (item.routeTo) ? item.routeTo : currentMainRoute;
      if (newRoute !== currentMainRoute)
        this.portal.isLoaded = false;

      const path = `/${newRoute}/${module.id}/${item.id}`;

      this.redirectToPath(path);
    }
  }

  forceCloseScript() {
    this.closeScript(null, true);
  }

  setScriptFluid(boolean) {
    if (!_.isBoolean(boolean)) return;
    this.portal.layout.script.fluid = boolean;
  }

  /**
   * =======
   * PORTAL
   * =======
   */
  setVisibilityEntity(boolean) {
    if (!_.isBoolean(boolean)) return;
    this.portal.layout.entity.show = boolean;
  }

  setVisibilityModules(boolean) {
    if (!_.isBoolean(boolean)) return;
    this.portal.layout.modules.show = boolean;
  }

  setVisibilityNav(boolean) {
    if (!_.isBoolean(boolean)) return;
    this.portal.layout.nav.show = boolean;
  }

  setVisibilityCloseScript(boolean) {
    if (!_.isBoolean(boolean)) return;
    this.company.closeScriptVisible = boolean;
  }

  setCompanyLogoVisibility(boolean) {
    if (!_.isBoolean(boolean)) return;
    this.company.companyLogoVisibility = boolean;
  }

  setLayoutFluid(boolean) {
    if (!_.isBoolean(boolean)) return;
    this.portal.layout.fluid = boolean;
  }

  /**
   * =====
   * SWAL
   * =====
   */

  swalReset() {
    this.proSwal.reset();
  }

  swalImage(link) {
    this.proSwal.showImage(link);
  }

  /**
   * @param {SwalParams} params
   */
  swal(params) {
    return this.proSwal.show(params);
  }

  swalClose() {
    this.proSwal.close();
  }

  swalQueue(arrayParam, defaultParam) {
    return this.proSwal.queue(arrayParam, defaultParam);
  }

  swalInsertQueue(param) {
    return this.proSwal.insertQueueStep(param);
  }

  connectionError(err, showSwal = true) {
    this.setActivity('connectionError', { error: _.get(err, 'message') || err }, true);

    if (showSwal) this.proSwal.connectionError(`Navegador: ${this.getBrowserInfo()}`);
  }

  /**
   * =========
   * REDIRECT
   * =========
   */

  sendTo404Page(urlToRedirect) {
    console.log('urlToRedirect', urlToRedirect);
    this.portal.urlRedirectNotfoundButton = urlToRedirect;
    return this.router.push('404');
  }

  sendToDisabledPage() {
    return this.router.push('/disabled');
  }

  sendToBlockedPage() {
    return this.router.push('/blocked');
  }

  sendToLogin(currentRoute) {
    this.portal.isLoaded = true;
    this.company.itemScriptLoading = false; // force closeScript()
    this.user.logout();
    return this.router.push({
      path: '/', // login path
      query: { redirect_url: typeof currentRoute === 'string' && currentRoute !== '/' ? currentRoute : undefined },
    });
  }

  sendToAppRoute(setLoadingState = false) {
    if (setLoadingState) this.portal.isLoaded = false;
    return this.router.push(this.getAppMainRoute());
  }

  sendToModuleByScript(script, uriComplementation) {
    if (!script) return;
    const isScript = item => item.script === script;
    const isModule = module => module.item.some(isScript);

    const moduleContent = this.company.json.module.find(isModule);
    const moduleObject = moduleContent.item.find(isScript);

    this.router.push(`/app/${moduleContent.id}/${moduleObject.id}${uriComplementation}`);
  }

  /**
   * Redireciona para uma rota setando loading no portal
   * @param {object} route route object
   */
  redirectToRoute(route, query = {}) {
    this.portal.isLoaded = false;
    return this.router.push({ path: route, query });
  }

  /**
   * Redireciona para uma rota caso não esteja aberta.
   * Evita o erro `NavigationDuplicated`
   * @param {string} path caminho da rota
   */
  redirectToPath(path) {
    /**
     * Se a rota atual for a que está sendo aberta
     */
    if (this.router.currentRoute.fullPath === path) return;

    return this.router.push({ path, query: this.router.currentRoute.query });
  }

  getAppMainRoute() {
    const companyLayout = _.get(this.company, 'json.style.layout');

    if (
      _.get(companyLayout, 'menu') === 'true'
      || _.get(companyLayout, 'menu') === true
    ) return '/menu';

    if (
      _.get(companyLayout, 'script') === 'true'
      || _.get(companyLayout, 'script') === true
    ) return '/script';

    return '/dashboard';
  }

  goBack() {
    if (typeof this.goBackFunction !== 'function') {
      console.error('Warning: The header back button function is not implemented for this view!');
      this.sendToAppRoute();
    }

    this.goBackFunction();
  }

  headerVisibility(boolean) {
    this.isHeaderHided = boolean;
  }

  /**
   * ================
   * ERRORS HANDLERS
   * ================
   */

  sessionError(currentRoute) {
    // FECHA OS MODEIS DE PROFILE E PASSWORD
    this.closeProfile();
    this.closePassword();

    // FECHA OS RESTANTES DOS MODAIS ABERTOS (para segurança e ctz!)
    $('.modal').modal('hide');
    $('.modal-backdrop').hide();

    // FECHA TODOS OS SWALS ABERTOS
    this.swalClose();
    this.sendToLogin(currentRoute);
  }

  getBrowserInfo() {
    const globalNavigator = _.get(global, 'window.navigator') || _.get(window, 'navigator') || navigator || {};
    const userAgent = globalNavigator.userAgent || '';
    let browser = '';
    let browserData = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(browserData[1])) {
      browser = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      return `IE ${browser[1] || ''}`;
    }

    if (browserData[1] === 'Chrome') {
      browser = userAgent.match(/\b(OPR|Edge|Edg)\/(\d+)/);

      if (browser && typeof browser === 'string') return browser.slice(1).join(' ').replace('OPR', 'Opera');

      if (Array.isArray(browser) && browser[1] === 'Edg') {
        browserData = browser;
        browserData[1] = 'Edge';
      }
    }

    browserData = browserData[2] ? [browserData[1], browserData[2]] : [globalNavigator.appName, globalNavigator.appVersion, '-?'];
    browser = userAgent.match(/version\/(\d+)/i);

    if (browser) browserData.splice(1, 1, browser[1]);

    return browserData.join(' ');
  }
}
